import React, {FC} from 'react'
import './JsonEditor.less'

interface Props {
    value: string
    onChange: (value: string) => void
}

export const JsonEditor: FC<Props> = ({value, onChange}) => {
    return (
        <textarea
            className="template-data-editor"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            spellCheck={false}
        />
    )
}
